import React, { useCallback } from 'react'
import { Button } from '@/components/button'
import Resx from '@/components/Resx'
import { BsrsGrid, commandColumnProps } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { WhiteBox } from '@/components/Layout'
import { dialogTypes } from '@/dialogs'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'
import { useDispatch } from '@/hooks/dispatch'
import { openDialog } from '@/store/Dialogs'
import { actionCreators } from '@/store/usersManagement'
import { useReduxState } from '@/hooks/reduxState'

export default function RolesBox (props) {
  const { localize } = useLocalization()
  const { internalLastReloadAt, externalLastReloadAt } = useReduxState(useCallback(state => ({
    internalLastReloadAt: state.usersManagement.internalLastReloadAt,
    externalLastReloadAt: state.usersManagement.externalLastReloadAt
  }), []))
  const actions = useDispatch({
    openDialog,
    addUserRole: actionCreators.addUserRole,
    removeUserRole: actionCreators.removeUserRole
  })

  return (
    <WhiteBox dataCy='RolesBox' header={props.internal ? 'UsersManagement.InternalRoles' : 'UsersManagement.ExternalRoles'}>
      <Button color='primary' className='btn-sm' onClick={() => actions.openDialog({
        dialogType: dialogTypes.addUserRole,
        primaryButtonText: 'Common.SaveAndClose',
        content: { userId: props.userId, internal: props.internal },
        onAction: (roleId) => {
          actions.addUserRole(props.userId, roleId, props.internal)
        }
      })} icon='plus'>
        <Resx name='Common.Add' />
      </Button>
      <BsrsGrid
        simpleView={props.simpleView}
        dataSource={(req) => props.internal ? context.api.userManagementService.getInternalUserRoles(props.userId, req) : context.api.userManagementService.getExternalUserRoles(props.userId, req)}
        lastReloadedAt={props.internal ? internalLastReloadAt : externalLastReloadAt}
        disableExcelExport>
        <Column field='displayName' title={localize('UsersManagement.Name')} />
        <Column title={localize('UsersManagement.Action')} {...commandColumnProps({ deleteAction: (dataItem) => actions.removeUserRole(props.userId, dataItem.id, props.internal) })} />
      </BsrsGrid>
    </WhiteBox>
  )
}



// WEBPACK FOOTER //
// ./src/components/usersManagement/rolesBox.js